module.exports = "img/17.181d12.webp";